import React from 'react';
import { Globe } from 'lucide-react';

const IntegrationSettings: React.FC = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-4">
        <div className="rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 p-3">
          <Globe className="h-6 w-6 text-white" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Integrations</h1>
          <p className="text-gray-600">Connect with third-party services and APIs</p>
        </div>
      </div>
      <div className="rounded-2xl border border-gray-200 bg-gray-50 p-8 text-center">
        <p className="text-gray-600">Integration settings content will be implemented here.</p>
      </div>
    </div>
  );
};

export default IntegrationSettings;
